import React, { useState, Fragment } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArticleCard } from './ArticleCard';
import { GptAdSlot } from './GptAdSlot';
const profiles = [{
  name: 'Hubert Boulos',
  title: 'Founder and CEO',
  company: 'Das Kapital'
}, {
  name: 'Tarek Miknas',
  title: 'CEO',
  company: 'FP7McCann MENAT'
}, {
  name: 'Hubert Boulos',
  title: 'Founder and CEO',
  company: 'Das Kapital'
}, {
  name: 'Tarek Miknas',
  title: 'CEO',
  company: 'FP7McCann MENAT'
}, {
  name: 'Hubert Boulos',
  title: 'Founder and CEO',
  company: 'Das Kapital'
}, {
  name: 'Tarek Miknas',
  title: 'CEO',
  company: 'FP7McCann MENAT'
}];
const heroSlides = [{
  image: 'https://cdn.magicpatterns.com/patterns/figma-images/TmuSK63UZRrBCoTmT1iulP/1052-13.png',
  title: 'The US agencies storming up the World Creative Rankings',
  description: "Special Group, a global independent creative network, was the year's biggest climber in North America."
}, {
  image: 'https://cdn.magicpatterns.com/patterns/figma-images/TmuSK63UZRrBCoTmT1iulP/1052-13.png',
  title: 'How MENA brands are redefining global advertising standards',
  description: 'Regional powerhouses are making waves on the international stage with bold creative campaigns and innovative strategies....'
}, {
  image: 'https://cdn.magicpatterns.com/patterns/figma-images/TmuSK63UZRrBCoTmT1iulP/1052-13.png',
  title: 'The rise of AI-powered creativity in the advertising industry',
  description: 'From generative visuals to automated copywriting, agencies are embracing artificial intelligence to push creative boundaries....'
}];
const imageVariants = {
  enter: (dir: number) => ({
    x: dir > 0 ? '100%' : '-100%'
  }),
  center: {
    x: '0%'
  },
  exit: (dir: number) => ({
    x: dir > 0 ? '-100%' : '100%'
  })
};
const textVariants = {
  enter: {
    opacity: 0
  },
  center: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
};
function SidebarArticleCard({
  hasImage,
  showPlus
}: {
  hasImage?: boolean;
  showPlus?: boolean;
}) {
  return <div className="relative w-full aspect-square overflow-hidden group cursor-pointer" style={{
    borderRadius: '25px',
    backgroundColor: '#D9D9D9'
  }} data-id="element-57">
      {hasImage && <img src="https://cdn.magicpatterns.com/patterns/figma-images/TmuSK63UZRrBCoTmT1iulP/1052-30.png" alt="Sponsored Article" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-58" />}
      <div className={`absolute inset-0 p-4 lg:p-5 flex flex-col justify-end ${hasImage ? 'bg-gradient-to-t from-black/70 via-black/15 to-transparent' : ''}`} data-id="element-59">
        <h3 className={`font-bold mb-1 ${hasImage ? 'text-white' : ''}`} style={{
        fontSize: '20px',
        fontFamily: 'Poppins',
        fontWeight: 700,
        lineHeight: 'normal',
        color: hasImage ? '#FFF' : '#6B6B6B',
        textShadow: hasImage ? '0px 4px 4px rgba(0,0,0,0.25)' : undefined
      }} data-id="element-60">
          The US agencies storming up the World Creative Rankings
        </h3>
        <span style={{
        fontSize: '15px',
        fontFamily: 'Poppins',
        fontWeight: 400,
        lineHeight: 'normal',
        color: hasImage ? '#FFF' : '#6B6B6B'
      }} data-id="element-61">
          By WPP
        </span>
      </div>
      {showPlus && <div className="absolute bottom-3 left-1/2 -translate-x-1/2" data-id="element-62">
          <span style={{
        color: '#6B6B6B'
      }} className="font-bold text-[30px] lg:text-[40px] leading-none" data-id="element-63">
            +
          </span>
        </div>}
    </div>;
}
export function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState(1);
  const nextSlide = () => {
    setDirection(1);
    setCurrentSlide(prev => (prev + 1) % heroSlides.length);
  };
  const prevSlide = () => {
    setDirection(-1);
    setCurrentSlide(prev => (prev - 1 + heroSlides.length) % heroSlides.length);
  };
  const slide = heroSlides[currentSlide];
  return <section className="w-full mx-auto py-4 lg:py-5" style={{
    maxWidth: '1770px',
    paddingLeft: '16px',
    paddingRight: '16px'
  }} data-id="element-64">
      <div className="flex flex-col xl:flex-row xl:items-start gap-4" style={{
      columnGap: '50px'
    }} data-id="element-65">
        {/* ===== LEFT CONTENT AREA ===== */}
        <div className="flex-1 flex flex-col min-w-0" data-id="element-66">
          <div className="flex flex-col xl:flex-row xl:items-start gap-4" style={{
          columnGap: '50px'
        }} data-id="element-67">
            {/* Left Profiles Column */}
            <div className="hidden xl:flex flex-col flex-shrink-0" style={{
            width: 'clamp(280px, 22vw, 380px)'
          }} data-id="element-68">
              <div className="flex justify-center relative z-10" data-id="element-69">
                <div className="bg-white inline-flex items-center justify-center" style={{
                borderRadius: '25px',
                padding: '8px 24px'
              }} data-id="element-70">
                  <span className="uppercase" style={{
                  color: '#6B6B6B',
                  fontSize: '13px',
                  letterSpacing: '0.1em'
                }} data-id="element-71">
                    The View
                  </span>
                </div>
              </div>
              <div className="w-full px-5 pt-6 pb-[65px] -mt-3 flex flex-col" style={{
              backgroundColor: '#D9D9D9',
              borderRadius: '25px'
            }} data-id="element-72">
                {profiles.map((p, i) => <Fragment key={i} data-id="element-73">
                    <div className="flex items-center gap-4 py-3 cursor-pointer transition-opacity duration-200 hover:opacity-70" data-id="element-74">
                      <img src="https://cdn.magicpatterns.com/patterns/figma-images/TmuSK63UZRrBCoTmT1iulP/1193-9.png" alt={p.name} className="rounded-full object-cover flex-shrink-0" style={{
                    width: '100px',
                    height: '100px',
                    border: '1px solid #F5F5F5'
                  }} data-id="element-75" />
                      <div className="flex flex-col min-w-0" data-id="element-76">
                        <span className="font-bold leading-snug" style={{
                      color: '#6B6B6B',
                      fontSize: '18px'
                    }} data-id="element-77">
                          {p.name}
                        </span>
                        <span className="leading-snug" style={{
                      color: '#6B6B6B',
                      fontSize: '15px'
                    }} data-id="element-78">
                          {p.title}
                        </span>
                        <span className="font-bold leading-snug" style={{
                      color: '#6B6B6B',
                      fontSize: '15px'
                    }} data-id="element-79">
                          {p.company}
                        </span>
                      </div>
                    </div>
                    {i < profiles.length - 1 && <div className="h-px opacity-30" style={{
                  backgroundColor: '#6B6B6B',
                  marginLeft: '116px'
                }} data-id="element-80" />}
                  </Fragment>)}
              </div>
              <div className="flex justify-center -mt-7 relative z-10" data-id="element-81">
                <div className="bg-white rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-50 shadow-sm transition-colors" style={{
                width: '60px',
                height: '60px'
              }} data-id="element-82">
                  <span style={{
                  color: '#6B6B6B'
                }} className="font-bold text-[45px] leading-none" data-id="element-83">
                    +
                  </span>
                </div>
              </div>
            </div>

            {/* Center Hero Column */}
            <div className="flex-1 flex flex-col min-w-0 lg:mt-[28px]" data-id="element-84">
              {/* Slider Container */}
              <div className="relative w-full" style={{
              aspectRatio: '960/502'
            }} data-id="element-85">
                {/* Clipping wrapper */}
                <div style={{
                position: 'absolute',
                inset: 0,
                overflow: 'hidden',
                borderRadius: '25px'
              }} data-id="element-86">
                  <AnimatePresence initial={false} custom={direction} data-id="element-87">
                    <motion.img key={currentSlide} src={slide.image} alt={slide.title} custom={direction} variants={imageVariants} initial="enter" animate="center" exit="exit" transition={{
                    x: {
                      type: 'tween',
                      duration: 0.5,
                      ease: [0.4, 0, 0.2, 1]
                    }
                  }} style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }} data-id="element-88" />
                  </AnimatePresence>
                </div>
                {/* Arrow buttons */}
                <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 bg-white rounded-full flex items-center justify-center hover:bg-gray-50 z-10 transition-colors shadow-sm" style={{
                width: '55px',
                height: '55px'
              }} data-id="element-89">
                  <span style={{
                  color: '#6B6B6B'
                }} className="font-bold text-[28px] lg:text-[38px] leading-none" data-id="element-90">
                    &lt;
                  </span>
                </button>
                <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 bg-white rounded-full flex items-center justify-center hover:bg-gray-50 z-10 transition-colors shadow-sm" style={{
                width: '55px',
                height: '55px'
              }} data-id="element-91">
                  <span style={{
                  color: '#6B6B6B'
                }} className="font-bold text-[28px] lg:text-[38px] leading-none" data-id="element-92">
                    &gt;
                  </span>
                </button>
              </div>

              {/* Headline Card - static white bg, text fades */}
              <div className="mx-4 lg:mx-6 -mt-8 relative z-10 bg-white px-5 py-4 lg:px-7 lg:py-5" style={{
              borderRadius: '25px'
            }} data-id="element-93">
                <AnimatePresence initial={false} mode="wait" data-id="element-94">
                  <motion.div key={currentSlide} variants={textVariants} initial="enter" animate="center" exit="exit" transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-95">
                    <h1 className="font-bold mb-2" style={{
                    color: '#6B6B6B',
                    fontSize: 'clamp(20px, 3.5vw, 50px)',
                    fontFamily: 'Poppins',
                    fontWeight: 700,
                    lineHeight: 'normal',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical' as const,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }} data-id="element-96">
                      {slide.title}
                    </h1>
                    <p style={{
                    color: '#6B6B6B',
                    fontSize: 'clamp(13px, 1.5vw, 25px)',
                    fontFamily: 'Poppins',
                    fontWeight: 400,
                    lineHeight: 'normal'
                  }} data-id="element-97">
                      {slide.description}
                    </p>
                  </motion.div>
                </AnimatePresence>
                <div className="flex items-center gap-2 mt-3" data-id="element-98">
                  {heroSlides.map((_, i) => <button key={i} onClick={() => {
                  setDirection(i > currentSlide ? 1 : -1);
                  setCurrentSlide(i);
                }} className="rounded-full transition-all duration-300" style={{
                  width: i === currentSlide ? '24px' : '8px',
                  height: '8px',
                  backgroundColor: i === currentSlide ? '#6B6B6B' : '#D9D9D9'
                }} data-id="element-99" />)}
                </div>
              </div>

              {/* Leaderboard Ad 728x90 */}
              <div className="mt-4 w-full flex items-center justify-center border-0" style={{
              backgroundColor: '#D9D9D9',
              border: 'none',
              borderRadius: '0'
            }} data-id="element-100">
                <img src="https://cdn.magicpatterns.com/uploads/aRvEPA7nKDuo2o2MzgvBvi/Leaderboard_728x90.png" alt="Leaderboard Ad" className="border-0 rounded-none w-full" style={{
                maxWidth: '728px',
                height: 'auto',
                display: 'block',
                border: 'none',
                borderRadius: '0'
              }} data-id="element-101" />
              </div>
            </div>
          </div>

          {/* ARTICLE ROW */}
          <div className="relative" style={{
          marginTop: '50px'
        }} data-id="element-102">
            <div className="grid grid-cols-1 md:grid-cols-3" style={{
            gap: '50px'
          }} data-id="element-103">
              <ArticleCard imageUrl="https://cdn.magicpatterns.com/patterns/figma-images/TmuSK63UZRrBCoTmT1iulP/1052-41.png" category="NEWS" index={0} data-id="element-104" />
              <ArticleCard imageUrl="https://cdn.magicpatterns.com/patterns/figma-images/TmuSK63UZRrBCoTmT1iulP/1052-41.png" category="OPINION" hasShadow index={1} data-id="element-105" />
              <ArticleCard imageUrl="https://cdn.magicpatterns.com/patterns/figma-images/TmuSK63UZRrBCoTmT1iulP/1052-41.png" category="INTERVIEW" hasShadow index={2} data-id="element-106" />
            </div>
            <div className="absolute -right-3 lg:-right-5 top-[25%] hidden md:block" data-id="element-107">
              <div className="bg-white rounded-full flex items-center justify-center shadow-sm cursor-pointer hover:bg-gray-50 transition-colors" style={{
              width: '35px',
              height: '35px'
            }} data-id="element-108">
                <span style={{
                color: '#6B6B6B'
              }} className="font-extrabold text-[20px] leading-none" data-id="element-109">
                  +
                </span>
              </div>
            </div>
          </div>

          {/* NEWSLETTER BAR */}
          <div className="mt-6 flex flex-col md:flex-row items-center gap-3 lg:gap-5" style={{
          backgroundColor: '#D9D9D9',
          borderRadius: '25px',
          padding: '12px 16px',
          minHeight: '55px'
        }} data-id="element-110">
            <span className="font-bold uppercase whitespace-nowrap flex-shrink-0" style={{
            color: '#6B6B6B',
            fontSize: '18px',
            letterSpacing: '0.1em'
          }} data-id="element-111">
              Stay in the know
            </span>
            <div className="relative flex-1 w-full" data-id="element-112">
              <input type="email" placeholder="" className="w-full border-0 outline-none" style={{
              height: '40px',
              borderRadius: '25px',
              backgroundColor: '#FFFFFF',
              padding: '0 20px',
              color: '#6B6B6B',
              fontSize: '12px'
            }} data-id="element-113" />
              <button className="absolute right-4 top-1/2 -translate-y-1/2 hover:opacity-70 transition-opacity" data-id="element-114">
                <img src="https://cdn.magicpatterns.com/patterns/figma-svgs/TmuSK63UZRrBCoTmT1iulP/1058-202.svg" alt="Submit" className="w-4 h-4 lg:w-5 lg:h-5" data-id="element-115" />
              </button>
            </div>
          </div>

          {/* Billboard Ad 970x250 */}
          <div className="mt-5 w-full flex items-center justify-center border-0" style={{
          backgroundColor: '#D9D9D9',
          border: 'none',
          borderRadius: '0'
        }} data-id="element-116">
            <img src="https://cdn.magicpatterns.com/uploads/81wWCkPrdq4acms41GQm8a/Leaderboard_728x90_(1).png" alt="Billboard Ad" className="border-0 rounded-none w-full" style={{
            maxWidth: '970px',
            height: 'auto',
            display: 'block',
            border: 'none',
            borderRadius: '0'
          }} data-id="element-117" />
          </div>
        </div>

        {/* ===== RIGHT SIDEBAR ===== */}
        <div className="hidden xl:flex flex-col flex-shrink-0" style={{
        width: 'clamp(280px, 22vw, 380px)'
      }} data-id="element-118">
          <div className="flex justify-center relative z-20" data-id="element-119">
            <div className="bg-white inline-flex items-center justify-center" style={{
            borderRadius: '25px',
            padding: '8px 24px'
          }} data-id="element-120">
              <span className="uppercase" style={{
              color: '#6B6B6B',
              fontSize: '13px',
              letterSpacing: '0.1em'
            }} data-id="element-121">
                Sponsored
              </span>
            </div>
          </div>
          <div className="w-full flex flex-col relative z-10" style={{
          gap: '50px',
          marginTop: '-10px'
        }} data-id="element-122">
            <SidebarArticleCard hasImage data-id="element-123" />
            <SidebarArticleCard hasImage data-id="element-124" />
            <SidebarArticleCard hasImage data-id="element-125" />
            <SidebarArticleCard hasImage showPlus data-id="element-126" />
          </div>
        </div>
      </div>
    </section>;
}